import React, { Component } from 'react';
import imagePath from '../images/PF-Logo-LLP.png'
import './style.css';


export class Header extends Component {

    RedirectToLandingPage(e) {
        e.preventDefault();
        if (window.parent)
            window.top.location.href = "/";
        else
            window.location.href = "/";
    }

    render() {
        return (
            <div>
                <div id="header">
                    <div className="PFLogo" role="logo">
                        <a href="http://pierse.ie">
                            <img src={imagePath} alt="Pierse Fitzgibbon Logo" />
                        </a>
                    </div>
                    <div id="headerContent" tabIndex="0">
                        <span className="titleField">Phone:</span><label>+353 (0)68 56700 or +353 (0)818 313 100 </label>
                        <span className="titleField">Email:</span>info@pierse.ie
                    </div>
                </div>
                <div id="headerMenu">
                    <a onClick={this.RedirectToLandingPage} aria-label="Home page Link">Home</a>
                </div>
            </div>
        );
    }
}